import React from 'react';
import { AVATAR_ICON_CLASS, AVATAR_PRESET_COLS, AVATAR_PRESETS } from '../../lib/avatarPresets';
import { cn } from '../../lib/utils';

/** Compact selectable grid of built-in avatar icons (config: lib/avatarPresets.js). */
export function AvatarPresetPicker({ value, onChange, disabled, className, testIdPrefix = 'avatar-preset' }) {
  return (
    <div
      className={cn(
        'rounded-tile border border-lap-hairline bg-lap-card/80 p-3 max-w-sm mx-auto w-full',
        className
      )}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${AVATAR_PRESET_COLS}, minmax(0, 1fr))`,
        gap: 10,
      }}
      data-testid={`${testIdPrefix}-grid`}
    >
      {AVATAR_PRESETS.map(({ id, Icon }) => {
        const selected = value === id;
        return (
          <button
            key={id}
            type="button"
            disabled={disabled}
            onClick={() => onChange?.(id)}
            className={cn(
              'aspect-square w-full rounded-full flex items-center justify-center box-border border-2',
              'transition-colors disabled:opacity-50',
              selected
                ? 'bg-lap-accent text-white border-lap-accent-bright'
                : 'bg-lap-raised text-lap-accent-bright border-transparent hover:bg-lap-accent/20'
            )}
            aria-label={`Choose ${id} icon`}
            aria-pressed={selected}
            data-testid={`${testIdPrefix}-${id}`}
          >
            <Icon className={AVATAR_ICON_CLASS} strokeWidth={2} aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
